import { RootState } from '../store'

export const getUserProfileState = (state: RootState) => state.userProfile
